import { useSeo } from "@/hooks/useSeo";

// Reusable interior-page hero banner with brand gradient.
export const PageHero = ({ overline, title, subtitle, seoTitle, seoDescription }) => {
  useSeo({ title: seoTitle, description: seoDescription });
  return (
    <section data-testid="page-hero" className="relative overflow-hidden bg-brand">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-dark via-brand to-brand-hover" />
      <div className="absolute -right-20 -top-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand-lilac/20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        {overline && <span className="overline !text-brand-lilac">{overline}</span>}
        <h1 className="mt-3 max-w-3xl font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/80">{subtitle}</p>}
      </div>
    </section>
  );
};
